import { apiPost, notifySuccess } from "@redriver/cinnamon";

const ActionTypes = {
  SendToIpsSignatory: "SHEETS/SEND_TO_IPS_SIGNATORY",
};

export const sendToIpsSignatory = ({ sheetId }) =>
  apiPost(
    ActionTypes.SendToIpsSignatory,
    `sheets/${sheetId}/send-to-ips-signatory`,
  );
